(function () {
  const LIGHT_SCHEME_PREFIX = 'color-scheme-f3484885';

  function isLightBackground(el) {
    const bg = getComputedStyle(el).backgroundColor;
    const match = bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (!match) return false;

    const r = Number(match[1]);
    const g = Number(match[2]);
    const b = Number(match[3]);

    return r >= 240 && g >= 240 && b >= 235;
  }

  function getParticleNode() {
    const template = document.getElementById('hing-particles-template');
    if (!template?.content?.firstElementChild) return null;
    return template.content.firstElementChild.cloneNode(true);
  }

  function injectParticles(host) {
    if (!host || host.dataset.hingParticlesInit === 'true') return;
    if (host.querySelector('.hing-particles')) return;

    const particles = getParticleNode();
    if (!particles) return;

    host.classList.add('hing-particles-host');

    if (getComputedStyle(host).position === 'static') {
      host.style.position = 'relative';
    }

    host.prepend(particles);
    host.dataset.hingParticlesInit = 'true';
  }

  function initHingParticles() {
    if (!document.body.classList.contains('template-index')) return;

    document.querySelectorAll(`[class*="${LIGHT_SCHEME_PREFIX}"]`).forEach(injectParticles);

    document.querySelectorAll('[class*="ai-itc-"]').forEach((el) => {
      if (isLightBackground(el)) injectParticles(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHingParticles);
  } else {
    initHingParticles();
  }

  document.addEventListener('shopify:section:load', initHingParticles);
})();
